import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomZenithFormGroupErrorComponent } from '../zenith/form/custom-zenith-form-group-error/custom-zenith-form-group-error.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { AsyncPipe } from '@angular/common';
import { InvalidAsyncPipe } from '../../shared/pipes/invalid-async.pipe';

@Component({
  selector: 'app-input-text',
  standalone: true,
  imports: [
    CustomZenithFormGroupErrorComponent,
    ReactiveFormsModule,
    ZenithComponentsModule,
    AsyncPipe,
    InvalidAsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <zenith-form-group>
      @if (label(); as label) {
        <zenith-form-group-label>{{ label }}</zenith-form-group-label>
      }
      @if (control(); as control) {
        <zenith-input-text
          [formControl]="control"
          [attr.zn-disabled]="disabled()"
          [attr.zn-invalid]="control | invalidAsync | async"
          [attr.zn-icon-name]="iconName()"
          [attr.zn-name]="name()"
          [attr.zn-readonly]="readonly()"
        />

        <custom-zenith-form-group-error [control]="control"></custom-zenith-form-group-error>
      } @else {
        <zenith-input-text
          [attr.zn-disabled]="disabled()"
          [attr.zn-icon-name]="iconName()"
          [attr.zn-name]="name()"
          [attr.zn-readonly]="readonly()"
          [attr.zn-value]="value()"
        />
      }
      @if (hint(); as hint) {
        <zenith-form-group-hint>{{ hint }}</zenith-form-group-hint>
      }
    </zenith-form-group>
  `
})
export class InputTextComponent {
  readonly control = input<FormControl<string | null> | null>(null);
  readonly name = input<string | null>(null);
  readonly label = input<string | null>(null);
  readonly disabled = input<boolean>(false);
  readonly iconName = input<string | null>();
  readonly hint = input<string | null>(null);
  readonly placeholder = input<string | null>(null);
  readonly readonly = input<boolean>(false);
  readonly value = input<string | null>(null);
}
